import { sm2Decrypt } from '@lcsc-design/utils/sm2';

/**
 * @desc: sm2解密
 * @param {string} str
 * @param {string} privateKey
 * @param {CipherMode} cipherMode
 * @return {*} 加密字符串
 * @author: 龙健
 */
export default function decryptSm2(str, privateKey) {
  // 兼容Java 删除04前缀
  const encryptData = str.substring(2);
  return sm2Decrypt(encryptData, privateKey);
}
